import { useBtns } from "../../Hooks/useBtns";

const Paged = ({ handlers }) => {
  const { allPages, numPages, pagHandler } = handlers;
  const { allBtns } = useBtns({ allPages, numPages });
  return (
    <>
      <div className="paged_container">
        <button name="back" onClick={pagHandler} className="btn-previus">
          {"<<<"}
        </button>
        {allPages > 1 &&
          allBtns.map((num) => (
            <button
              key={num}
              name="index"
              value={num}
              onClick={pagHandler}
              className={
                Number(numPages) === num ? "btn-pageActive" : "btn-page"
              }
            >
              {num + 1}
            </button>
          ))}
        <button name="next" onClick={pagHandler} className="btn-next">
          {">>>"}
        </button>
      </div>
    </>
  );
};

export default Paged;
